import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalCacheManager } from '../managers/local-cache.manager';
import { ToroEditScheduleModel } from '../models/toro-edit-schedule.model';
import { ApiUrlService } from './api-url.service';
import { ApiService } from './api.service';

@Injectable()
export class ProgramApiService extends ApiService
{

    constructor(protected http: HttpClient, protected apiUrlService: ApiUrlService, protected localCacheManager: LocalCacheManager)
    {
        super(http, localCacheManager);
    }

    saveProgram(controllerId: number, programNumber: number, description: string): Observable<{ Success: boolean, Error: string }>
    {
        return this.apiRequest(this.apiUrlService.getSaveProgramUrl(controllerId, programNumber), this.HttpMethod.Put, { description });
    }

    saveSchedule(controllerId: number, programNumber: number, schedule: ToroEditScheduleModel): Observable<{ Success: boolean, Error: string }>
    {
        return this.apiRequest(this.apiUrlService.getSaveScheduleUrl(controllerId, programNumber), this.HttpMethod.Put, JSON.stringify(schedule));
    }
}
